import type { ReactNode } from "react";
export function PageHeader({
	title,
	description,
	eyebrow,
	actions,
}: { title: string; description?: string; eyebrow?: string; actions?: ReactNode }) {
	return (
		<header className="mb-8 flex flex-wrap items-start justify-between gap-4">
			<div className="min-w-0 max-w-prose">
				{eyebrow && <p className="mb-2 text-xs font-semibold text-muted-foreground">{eyebrow}</p>}
				<h1 className="text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">{title}</h1>
				{description && <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{description}</p>}
			</div>
			{actions && <div className="flex flex-wrap gap-2">{actions}</div>}
		</header>
	);
}
